$(document).ready(function () {
  initDropContainers();
});

function initDropContainers() {
  const dropContainers = document.querySelectorAll('[data-drop-container]');

  dropContainers.forEach(function (dropContainer) {
    const fileInput = document.getElementById(
      dropContainer.dataset.dropContainer
    );
    const fileCategory = dropContainer.dataset.dropCategory;

    // dragover and dragenter events need to have 'preventDefault' called
    // in order for the 'drop' event to register.
    // See: https://developer.mozilla.org/en-US/docs/Web/Guide/HTML/Drag_operations#droptargets
    dropContainer.ondragenter = dropContainer.ondragover = function (event) {
      event.preventDefault();
    };

    dropContainer.ondrop = function (event) {
      const dropTarget = document.getElementsByClassName(
        `js-after-drop ${fileCategory}`
      )[0];
      dropTarget.classList.remove('d-none');
      dropTarget.classList.add('dropzone-active');

      fileInput.files = event.dataTransfer.files;

      showFileInput();
      event.preventDefault();
    };
  });
}
